import {
  Button,
  Heading,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spinner,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { RiDeleteBin5Fill } from "react-icons/ri";

const DeleteFileConfirmModal = ({
  isOpen,
  onClose,
  deleteFileLoader,
  setDeleteFileLoader,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size={"sm"}>
      <ModalOverlay />
      <ModalContent borderRadius={"20px"} py={3} px={1}>
        <ModalHeader marginX={"auto"}>
          {deleteFileLoader ? (
            <Spinner
              thickness="4px"
              speed="0.65s"
              emptyColor="gray.200"
              color="red.500"
              size="xl"
            />
          ) : (
            <RiDeleteBin5Fill className="h-12 w-12 text-red-500" />
          )}
        </ModalHeader>
        <ModalBody
          display={"flex"}
          justifyContent={"center"}
          flexDirection={"column"}
          alignItems={"center"}
          rowGap={2}
        >
          <Heading width={"50%"} as="h3" size="sm" textAlign={"center"}>
            {deleteFileLoader
              ? "Deleting the File..."
              : "Are you sure to delete this file?"}
          </Heading>
          <Text fontSize={"sm"}>Deleted files cannot be recovered</Text>
        </ModalBody>
        <ModalFooter
          display={"flex"}
          flexDirection={"column"}
          rowGap={4}
          alignItems={"center"}
        >
          <Button
            width={"100%"}
            colorScheme="red"
            onClick={setDeleteFileLoader}
            disabled={deleteFileLoader}
          >
            Delete
          </Button>
          <Button
            width={"100%"}
            onClick={onClose}
            variant={"outline"}
            disabled={deleteFileLoader}
          >
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteFileConfirmModal;
